export const LangKeys: string[] = ['id', 'bd', 'bn']

export const standardCountryLanguageCodes: { [key: string]: string } = {
    'id': 'id-ID',
    'bd': 'bn-BD',
    'bn': 'bn-BD',
}